import React, { useState, useContext } from 'react';
import { Table, Space, Button, notification } from 'antd';
import { API, graphqlOperation } from 'aws-amplify';
import {
  createProducer,
  updateProducer,
  deleteProducer,
} from '../../graphql/mutations';
import DeletePopover from '../DeletePopover';
import ProducerDrawer from './ProducerDrawer';
import EventContext from '../../context/event/eventContext';
import {
  EditOutlined,
  DeleteFilled,
  PlusCircleFilled,
} from '@ant-design/icons';

const ProducerList = () => {
  const eventContext = useContext(EventContext);
  const { isAdmin, producers } = eventContext;

  const [isShowing, setIsShowing] = useState(false);
  const [mode, setMode] = useState('add');
  const [currentProducer, setCurrentProducer] = useState({
    id: null,
    faculty: '',
    school: '',
  });

  const producerColumns = [
    {
      title: 'FACULTY',
      dataIndex: 'faculty',
      key: 'faculty',
      sorter: {
        compare: (a, b) => a.faculty.localeCompare(b.faculty),
        multiple: 2,
      },
    },
    {
      title: 'SCHOOL',
      dataIndex: 'school',
      key: 'school',
      sorter: {
        compare: (a, b) => {
          if (a.school && b.school) {
            return a.school.localeCompare(b.school)
          } else {
            return -1;
          }
        },
        multiple: 1,
      },
    },
    {
      title: 'EVENT URL',
      dataIndex: 'event_url',
      key: 'event_url',
    },
    {
      title: 'ACTION',
      key: 'action',
      width: '200px',
      render: (text, record) =>
        record.showButtons ? (
          <Space size='middle'>
            <Button
              shape='round'
              size='small'
              icon={<EditOutlined />}
              onClick={() => handleEdit(record)}
            >
              Edit
            </Button>
            <DeletePopover deleteHandler={handleDeleteProducer} record={record}>
              <Button shape='round' size='small' danger icon={<DeleteFilled />}>
                Delete
              </Button>
            </DeletePopover>
          </Space>
        ) : (
          '-'
        ),
    },
  ];

  const handleEdit = (producer) => {
    setMode('edit');
    setCurrentProducer({
      id: producer.id,
      faculty: producer.faculty,
      school: producer.school,
    });
    setIsShowing(true);
  };

  const closeDrawer = () => {
    setMode('add');
    setCurrentProducer({ id: null, faculty: '', school: '' });
    setIsShowing(false);
  };

  const handleAddProducer = async (values) => {
    // console.log('Add Producer', values);
    try {
      const input = { faculty: values.faculty, school: values.school };
      await API.graphql(graphqlOperation(createProducer, { input }));
      closeDrawer();
      notification.success({
        message: 'Success',
        duration: 2,
        description: 'Producer By has been added successfully.',
      });
    } catch (err) {
      console.error(err);
    }
  };

  const handleEditProducer = async (values) => {
    // console.log("Edit Producer", values)
    try {
      const input = {
        id: currentProducer.id,
        faculty: values.faculty,
        school: values.school,
      };
      await API.graphql(graphqlOperation(updateProducer, { input }));
      closeDrawer();
      notification.success({
        message: 'Success',
        duration: 2,
        description: 'Producer has been updated successfully.',
      });
    } catch (err) {
      console.error(err);
    }
  };

  const handleDeleteProducer = async (id) => {
    try {
      const input = { id };
      await API.graphql(graphqlOperation(deleteProducer, { input }));
      notification.success({
        message: 'Success',
        duration: 2,
        description: 'Producer has been deleted successfully.',
      });
    } catch (err) {
      console.error(err);
    }
  };

  const onFinishFailed = (error) => {
    console.error('Submission Failed:', error);
  };

  const kebabCase = (string) => {
    return string.replace(/\'+/g, '').replace(/[^\w]+/g, '-').toLowerCase();
  }

  const dataSource = producers.map((item) => {
    const currLocation = window.location.href;
    const frontendUrl = currLocation.includes('test') ? 'https://whatson.testing.sydney.edu.au/events' : 'https://whatson.sydney.edu.au/events'
    return {
      ...item,
      key: item.id,
      showButtons: isAdmin,
      event_url: item.school ? `${frontendUrl}/${kebabCase(item.faculty)}/${kebabCase(item.school)}` : `${frontendUrl}/${kebabCase(item.faculty)}`
    }
  });

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          paddingBottom: '8px',
        }}
      >
        <h2>
          Total number of Producers
          <span className='badge'>{dataSource.length}</span>
        </h2>
        {isAdmin && (
          <Button
            shape='round'
            size='small'
            type='primary'
            onClick={() => setIsShowing(true)}
          >
            <PlusCircleFilled /> Add Producer
          </Button>
        )}
      </div>

      {isShowing && (
        <ProducerDrawer
          title='producer'
          mode={mode}
          isShowing={isShowing}
          closeDrawer={closeDrawer}
          handleAddName={handleAddProducer}
          handleEditName={handleEditProducer}
          onFinishFailed={onFinishFailed}
          currentEntry={currentProducer}
        />
      )}

      <Table
        dataSource={dataSource}
        columns={producerColumns}
        pagination={{ pageSize: 100 }}
        size='small'
      />
    </>
  );
};

export default ProducerList;
